import { createStore } from 'vuex';

interface State {
  isVideoModal: boolean;
  isMenu: boolean;
  isFooter: boolean;
}

export default createStore<State>({
  state: {
    isVideoModal: false,
    isMenu: true,
    isFooter: true,
  },
  getters: {
    isVideoModalStatus: (state) => state.isVideoModal,
    isMenuStatus: (state) => state.isMenu,
    isFooterStatus: (state) => state.isFooter,
  },
  mutations: {
    SET_VIDEO_PLAYER(state) {
      state.isVideoModal = !state.isVideoModal;
    },
    SET_MENU(state) {
      state.isMenu = !state.isMenu;
    },
    SET_FOOTER(state) {
      state.isFooter = !state.isFooter;
    },
  },
  actions: {},
  modules: {},
});
